import { render, staticRenderFns } from "./DetalleTransferencia.vue?vue&type=template&id=9cb36342&scoped=true"
import script from "./DetalleTransferencia.vue?vue&type=script&lang=ts"
export * from "./DetalleTransferencia.vue?vue&type=script&lang=ts"
import style0 from "./DetalleTransferencia.vue?vue&type=style&index=0&id=9cb36342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb36342",
  null
  
)

export default component.exports